import { assertLoggingAllowed, checkInStateOn } from "../../domain/check-in/state-machine";
import type { Clock } from "../ports/clock";
import type { DiaryRepository, WeekPlanRepository } from "../ports/repositories";

export async function deleteDiaryEntry(
  dependencies: {
    diary: DiaryRepository;
    weekPlans: WeekPlanRepository;
    clock: Clock;
  },
  entryId: string,
): Promise<void> {
  const [entry, plan] = await Promise.all([
    dependencies.diary.getById(entryId),
    dependencies.weekPlans.getOpen(),
  ]);
  if (!entry) throw new Error("Diary entry not found");
  if (!plan) throw new Error("No active week plan exists");
  const state = checkInStateOn(plan, dependencies.clock.today());
  assertLoggingAllowed(
    plan,
    dependencies.clock.today(),
    entry.date,
    state === "overdue_locked" ? "check_in_backfill" : "normal",
  );
  await dependencies.diary.delete(entryId);
}
